import React from "react";
import Register from "./Register";
import Subscribe from "./Subscribe";
import FooterLinks from "./FooterLinks";

const Footer = () => {
  const allowSubscriptions = false;

  return (
    <>
      <Register allowSubscriptions={allowSubscriptions} />
      {allowSubscriptions && <Subscribe />}
      <FooterLinks allowSubscriptions={allowSubscriptions} />
    </>
  );
};

export default Footer;
